/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { genUrl, getAuthHeaders } from './request';

interface ReqParams {
  endpoint: string;
  queryParams?: { [key: string]: string };
}

/**
 * Streaming counterpart to `request`. Returns the raw `Response` so the
 * caller can read `response.body` as a stream (e.g. for SSE). Unlike
 * `request.post`, the body is NOT consumed here.
 */
export const stream = {
  post: async (
    req: ReqParams,
    body?: unknown,
    mgmt?: boolean,
    evals?: boolean,
    sreAgent?: boolean,
    signal?: AbortSignal
  ): Promise<Response> => {
    const authHeaders = await getAuthHeaders();

    const url = mgmt
      ? genUrl(req.endpoint, req.queryParams, true)
      : evals
        ? genUrl(req.endpoint, req.queryParams, false, false, true)
        : sreAgent
          ? genUrl(req.endpoint, req.queryParams, false, false, false, true)
          : genUrl(req.endpoint, req.queryParams);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...authHeaders,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal,
    });

    if (process.env.NODE_ENV === 'development') {
      console.log('[API stream response]', {
        method: 'POST',
        url,
        status: response.status,
        ok: response.ok,
      });
    }

    return response;
  },
};
